// extracted by mini-css-extract-plugin
export default {"container":"op-z","heading":"pp-z","text":"qp-z","info":"rp-z","link":"sp-z","fullMaxWidth":"tp-z"};